import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import SectionIntro from './SectionIntro';
import { processSteps } from '../data/content';

function Process() {
  const reduceMotion = useReducedMotion();

  return (
    <section className="section process">
      <div className="container">
        <SectionIntro
          eyebrow="How It Works"
          title="From First Call to Final Walkthrough"
          centered
        />
        <div className="process-grid">
          <motion.div
            className="process-line"
            initial={reduceMotion ? false : { scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, margin: '-130px' }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          />
          {processSteps.map((step, index) => (
            <motion.article
              key={step.title}
              initial={reduceMotion ? false : { opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ delay: index * 0.12 }}
            >
              <span className="step-number">0{index + 1}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;